import React, { createContext, useContext, useEffect, useState } from 'react'
import { HeaderContentTypes } from '@toasttab/shared/src/components/organisms/Navigation/Contentful/ContentfulNavigation.d'

export interface PageContextProps {
  activeGlobalBanner?: string
  activeRegionSwitcherInfoBanner?: boolean
  allEntries?: any[]
  breadcrumbs?: any[]
  disclaimers?: any[]
  footerContent?: any
  headerHeight?: number
  globalSettings?: any
  headerContent?: HeaderContentTypes
  headerData?: HeaderContentTypes
  headerOverride?: HeaderContentTypes
  headerStyle?: 'Default' | 'Logo Only' | 'Logo & Login'
  isPricingTest?: boolean // MKE-3840: September Pricing Test
  isLP?: boolean
  isDataPage?: boolean
  isRegionBannerActive?: boolean
  language?: string
  localizedEntries?: any[]
  location?: any
  microCopyData?: any[]
  packageName?: string
  region?: 'US' | 'UK' | 'CA' | 'IE' | 'AU'
  regions?: any
  salesIndicatorSchedule?: any
  setActiveGlobalBanner?: (activeBanner: string) => void
  setActiveRegionSwitcherInfoBanner?: (isActive: boolean) => void
  setHeaderHeight?: (value: number) => void
  setIsRegionBannerActive?: (isActive: boolean) => void
  setIsPricingTest?: (isActive: boolean) => void // MKE-3840: September Pricing Test
  siteId?: number
  siteMetadata?: any
  slug?: string
  styleContext?: string
  title?: string
  url?: string
  urlParams?: any
}

const pageContextDefaults: PageContextProps = {
  packageName: 'main',
  region: 'US'
}
export const PageContext = createContext<PageContextProps | undefined>({
  ...pageContextDefaults
})

export const PageContextProvider = ({
  value,
  children
}: {
  value?: PageContextProps
  children: any
}) => {
  const [activeGlobalBanner, setActiveGlobalBanner] = useState(null)
  const [activeRegionSwitcherInfoBanner, setActiveRegionSwitcherInfoBanner] =
    useState(null)
  const [headerHeight, setHeaderHeight] = useState(0)
  const [isRegionBannerActive, setIsRegionBannerActive] = useState(false)
  const [isPricingTest, setIsPricingTest] = useState(false)
  const [urlParams, setUrlParams] = useState(null)

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const params = new URLSearchParams(window.location.search)
      setUrlParams(params)
    }
  }, [])

  return (
    <PageContext.Provider
      value={{
        ...pageContextDefaults,
        ...value,
        activeGlobalBanner,
        headerHeight,
        setHeaderHeight,
        isRegionBannerActive,
        setActiveGlobalBanner,
        setIsRegionBannerActive,
        activeRegionSwitcherInfoBanner,
        setActiveRegionSwitcherInfoBanner,
        isPricingTest,
        setIsPricingTest,
        urlParams
      }}
    >
      {children}
    </PageContext.Provider>
  )
}

export const usePageContext = () => {
  const context = useContext(PageContext)
  // Throw error if context is undefined, but allow this to run if in a Jest test environment
  // Todo - remove this Jest check and add context to the offending tests
  if (!context) {
    if (
      typeof process !== 'undefined' &&
      process.env.JEST_WORKER_ID !== undefined
    ) {
      return {}
    } else {
      throw new Error('usePageContext must be used within a PageContext')
    }
  }
  return context
}
